import * as actionTypes from './actionTypes';

/**
* @desc actions for candidate profile reducer
* @version
* @author Lakshmikanth 
* @return action and parameters
*/
export const handlePoolStatusChange= ( candidateId, status, jobId, isReviewAll, regretReason,scoredBy,score, totalScore,scoredByName,prevStatus ) => {
  return {
    type: actionTypes.UPDATE_CANDIDATE_STATUS,
    candidateId: candidateId,
    jobId: jobId,
    status: status,
    isReviewAll: isReviewAll,
    regretReason:regretReason,
    scoredBy:scoredBy,
    score:score,
    totalScore: totalScore,
    scoredByName:scoredByName,
    prevStatus:prevStatus
  };
};

export const getProfileDetails = (candidateId, jobTitleId,isClient,user) => {
  return {
    type: actionTypes.GET_PROFILE_DETAILS,
    jobTitleId: jobTitleId,
    candidateId: candidateId,
    isClient:isClient,
    user:user
  };
};

export const setCandidateProfile = (profileInfo) => {
  return {
    type: actionTypes.SET_PROFILE_DETAILS,
    profileInfo: profileInfo
  };
};

export const setStatus = (candidateId,status, score, totalScore) => {
  return {
    type: actionTypes.SET_CANDIDATE_STATUS,
    candidateId:candidateId,
    status:status,
    score: score,
    totalScore: totalScore
  };
};

export const signOutCandidateProfile = () => {
  return {
    type: actionTypes.COGNITO_LOGOUT
  };
};

export const updateCandidateProfileImage = (candidateImage,candidateId,user) => {
  return {
    type: actionTypes.UPDATE_CANDIDATE_PROFILE_IMAGE,
    candidateImage:candidateImage,
    candidateId:candidateId,
    user:user
  };
};

export const setCandidateProfileImage = (s3SignedUrl,candidateImage) => {
  return {
    type: actionTypes.SET_CANDIDATE_PROFILE_IMAGE,
    s3SignedUrl:s3SignedUrl,
    candidateImage:candidateImage
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/candidateProfile.js